import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71bb4375"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "groupLevelInformation" }
const _hoisted_2 = { class: "groupLevelInformation__topCover" }
const _hoisted_3 = { class: "generalInformation__title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "generalInformation__testClass" }, " puedes probar una clase SIN COSTO! ", -1))
const _hoisted_5 = { class: "groupLevelInformation__groupsInformation" }
const _hoisted_6 = { class: "groupsInformation__list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LevelDescription = _resolveComponent("LevelDescription")!
  const _component_GroupLevelFlipCard = _resolveComponent("GroupLevelFlipCard")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.thisGroupLevel.name) + " Groups", 1),
      _hoisted_4
    ]),
    _createVNode(_component_LevelDescription, { levelData: _ctx.thisGroupLevel }, null, 8, ["levelData"]),
    _createElementVNode("section", _hoisted_5, [
      _createElementVNode("ul", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.thisGroupLevel.groups, (group) => {
          return (_openBlock(), _createElementBlock("li", {
            key: group.groupRoute,
            class: "list__item"
          }, [
            _createVNode(_component_GroupLevelFlipCard, { thisGroup: group }, null, 8, ["thisGroup"])
          ]))
        }), 128))
      ])
    ])
  ]))
}